import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Download Istantaneo', 'Nessun Abbonamento', 'Accesso a Vita', 'Garanzia di 7 Giorni'];
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-20 pt-5" data-id="element-110" data-mp="9lbfqzxtf9d2">
      <div className="mx-auto max-w-4xl text-center" data-id="element-111" data-mp="4m8mecr76rkx">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="font-display text-[2.5rem] font-black leading-[1.02] tracking-tight text-ink sm:text-6xl md:text-[4.2rem]" data-id="element-112" data-mp="4jm4pkalevoz">
          Risolvi un Intero Anno di Lezioni di Geografia in soli{' '}
          <span className="italic text-brand" data-id="element-113" data-mp="nbop96qcuw4i">5 Minuti</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-ink/60 sm:text-lg" data-id="element-114" data-mp="3d2labedjz91r">
          Unisciti a oltre 1.200 insegnanti che hanno smesso di improvvisare. Entra in classe con
          tutto pronto per spiegare, mappare e ispirare.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-2 max-w-2xl pb-5 pt-2.5 sm:mt-8" data-id="element-115" data-mp="3e9fs5f0aqamq">
          <img src="https://cdn.magicpatterns.com/uploads/aCEaRqbpK948SCEUdWvRev/44300978-3e73-4a2b-bd52-74690e6c3dd4.webp" alt="Il pacchetto GEOGRAFIA PRONTA: gli otto volumi dalla 1ª Primaria alla 3ª Media con mappe fisiche e politiche, infografiche visuali, attività pronte all'uso e i 5 bonus strategici inclusi" className="mx-auto w-[70%] max-w-sm sm:w-[66%]" data-id="element-116" data-mp="35a2fyeksf7yb" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} className="-mt-2 sm:mt-8" data-id="element-117" data-mp="s21kmih80q35">
          <CtaButton href="#offer" data-id="element-118" data-mp="ibgjana5x7gj" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-ink/50 sm:text-sm" data-id="element-119" data-mp="ichxh0mh6a2h">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-120" data-mp="1b0dte347zxy7" data-mpi={index}>
                <span data-id="element-121" data-mp="161jal16969e3">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-ink/25" data-id="element-122" data-mp="1126owjr4b8d3">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}